export enum ImageGeneratorType {
  Generate = 'gen',
  Fill = 'fill',
  EnhanceImage = 'enhance-image',
  ImageToVideo = 'image-to-video',
  Mio = 'mio',
}

export const ALLOWED_GENERATOR_TABS = ['editor', 'enhancement', 'animation']
export const generatorTabParamsToModeMap = {
  editor: ImageGeneratorType.Fill,
  enhancement: ImageGeneratorType.EnhanceImage,
} satisfies Record<(typeof ALLOWED_GENERATOR_TABS)[number], ImageGeneratorType>

export const DEFAULT_SIZE = { width: 512, height: 768 }
export const DEFAULT_XL_SIZE = { width: 768, height: 1280 }
export const DEFAULT_DITV1_SIZE = DEFAULT_XL_SIZE
